import { useEffect, useState } from 'react'
import { Link, useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { api } from '../lib/api'
import { CODE_AGENTS, CODE_HOME, chatTarget } from '../lib/chatNavigation'

export default function NewCodeConversationPage() {
  const { agent } = useParams()
  const [params, setParams] = useSearchParams()
  const navigate = useNavigate()
  const [fallbackId] = useState(() => crypto.randomUUID())
  const launchId = params.get('launch_id')
  const meta = CODE_AGENTS.find((entry) => entry.agent === agent)
  const validId = !!launchId && /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(launchId)
  const { data, error, refetch, isFetching } = useQuery({
    queryKey: ['new-code-conversation', meta?.chatId, launchId],
    queryFn: () => api<{ id: string }>(`/api/chats/${meta?.chatId}/topics`, {
      method: 'POST',
      signal: AbortSignal.timeout(10_000),
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ opening_prompt: '', client_topic_id: launchId }),
    }),
    enabled: !!meta && validId,
    retry: false,
    staleTime: Infinity,
    gcTime: 0,
  })

  useEffect(() => {
    if (!launchId) setParams({ launch_id: fallbackId }, { replace: true })
  }, [launchId, fallbackId, setParams])

  useEffect(() => {
    if (!data || !meta) return
    navigate(`${chatTarget(meta.chatId, data.id, { parentTab: 'code' })}&focus_composer=1`, { replace: true })
  }, [data, meta, navigate])

  if (!meta || (launchId && !validId) || error) {
    return (
      <div className="grid h-full place-items-center px-6 text-center">
        <div>
          <p role="alert" className="mb-4 text-sm">{error instanceof Error ? error.message : 'Invalid Code shortcut'}</p>
          {meta && validId && <button disabled={isFetching} onClick={() => void refetch()} className="mr-4 text-sm underline">Retry</button>}
          <Link to={CODE_HOME} replace className="text-sm underline">Show Code conversations</Link>
        </div>
      </div>
    )
  }
  return <div className="grid h-full place-items-center text-sm text-stone-500">Opening {meta.label} Code...</div>
}
